import React, { useEffect, useState } from "react";
import { Line } from "react-chartjs-2";
import axios from "axios";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const HargaChart = () => {
  const [chartData, setChartData] = useState(null);

  useEffect(() => {
    fetchDataForChart();
  }, []);

  const fetchDataForChart = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(
        "https://c-greenproject.org:8000/hargaforchart",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const data = response.data;

      const labels = data.map((item) => item.tanggalupdateharga);

      setChartData({
        labels,
        datasets: [
          {
            label: "Harga Grade A",
            data: data.map((item) => item.hargaGradeA),
            borderColor: "rgb(31, 80, 154)",
            backgroundColor: "rgba(31, 80, 154, 0.5)",
            tension: 0.4,
          },
          {
            label: "Harga Grade B",
            data: data.map((item) => item.hargaGradeB),
            borderColor: "rgb(255, 204, 29)",
            backgroundColor: "rgba(255, 204, 29, 0.5)",
            tension: 0.4,
          },
          {
            label: "Harga Grade C",
            data: data.map((item) => item.hargaGradeC),
            borderColor: "rgb(60, 207, 78)",
            backgroundColor: "rgba(60, 207, 78, 0.5)",
            tension: 0.4,
          },
        ],
      });
    } catch (error) {
      console.error("Error fetching chart data:", error.message);
    }
  };

  return (
    <div className="chart-container mb-3" style={{ maxWidth: "100%", margin: "0 auto" }}>
      <h4 className="fw-bold mb-1 pt-4 text-center">
        <strong>Grafik Harga Jual (per kilogram)</strong>
      </h4>
      {chartData ? (
        <Line
          data={chartData}
          options={{
            responsive: true,
            maintainAspectRatio: false,
            aspectRatio: window.innerWidth < 768 ? 1 : 2.5,
            plugins: {
              legend: {
                position: "bottom",
              },
              title: {
                display: true,
                text: "Perubahan Harga Berdasarkan Tanggal",
              },
              tooltip: {
                callbacks: {
                  label: function (context) {
                    const value = context.raw;
                    return `Rp ${new Intl.NumberFormat("id-ID").format(value)}`;
                  },
                },
              },
            },
            scales: {
              x: {
                ticks: {
                  maxRotation: 45,
                  minRotation: 0,
                },
              },
              y: {
                beginAtZero: false,
              },
            },
          }}
          style={{ minHeight: "250px", maxHeight: "400px" }}
        />
      ) : (
        <p>Loading chart...</p>
      )}
    </div>
  );
};

export default HargaChart;
